import { render, staticRenderFns } from "./AdminCreateuserForm.vue?vue&type=template&id=2f38a9be&scoped=true"
import script from "./AdminCreateuserForm.vue?vue&type=script&lang=js"
export * from "./AdminCreateuserForm.vue?vue&type=script&lang=js"
import style0 from "./AdminCreateuserForm.vue?vue&type=style&index=0&id=2f38a9be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f38a9be",
  null
  
)

export default component.exports